export class PerformanceReturn {
	private _uniqueId: string;
	private _hasReturnsData: boolean;
	private _asOfDate: Date;
	private _chartData: Array<any>;
	private _fiveYear: number;
	private _lastMonth: number;
	private _lastQuarter: number;
	private _oneYear: number;
	private _threeYear: number;
	private _yearToDate: number;
	private _sinceInception: number;
	private _benchmarkName: string;
	private _benchmarkLastMonth: number;
	private _benchmarkLastQuarter: number;
	private _benchmarkYearToDate: number;
	private _benchmarkOneYear: number;
	private _benchmarkThreeYear: number;
	private _benchmarkFiveYear: number;
	private _benchmarkSinceInception: number;

	public get uniqueId(): string {
		return this._uniqueId;
	}

	public set uniqueId(value: string) {
		this._uniqueId = value;
	}

	public get hasReturnsData(): boolean {
		return this._hasReturnsData;
	}

	public set hasReturnsData(value: boolean) {
		this._hasReturnsData = value;
	}

	public get asOfDate(): Date {
		return this._asOfDate;
	}

	public set asOfDate(value: Date) {
		this._asOfDate = value;
	}

	public get chartData(): Array<any> {
		return this._chartData;
	}

	public set chartData(value: Array<any>) {
		this._chartData = value;
	}

	public get fiveYear(): number {
		return this._fiveYear;
	}

	public set fiveYear(value: number) {
		this._fiveYear = value;
	}

	public get lastMonth(): number {
		return this._lastMonth;
	}

	public set lastMonth(value: number) {
		this._lastMonth = value;
	}

	public get lastQuarter(): number {
		return this._lastQuarter;
	}

	public set lastQuarter(value: number) {
		this._lastQuarter = value;
	}

	public get oneYear(): number {
		return this._oneYear;
	}

	public set oneYear(value: number) {
		this._oneYear = value;
	}

	public get threeYear(): number {
		return this._threeYear;
	}

	public set threeYear(value: number) {
		this._threeYear = value;
	}

	public get yearToDate(): number {
		return this._yearToDate;
	}

	public set yearToDate(value: number) {
		this._yearToDate = value;
	}

	public get sinceInception(): number {
		return this._sinceInception;
	}

	public set sinceInception(value: number) {
		this._sinceInception = value;
	}

	public get benchmarkName(): string {
		return this._benchmarkName;
	}

	public set benchmarkName(value: string) {
		this._benchmarkName = value;
	}

	public get benchmarkLastMonth(): number {
		return this._benchmarkLastMonth;
	}

	public set benchmarkLastMonth(value: number) {
		this._benchmarkLastMonth = value;
	}

	public get benchmarkLastQuarter(): number {
		return this._benchmarkLastQuarter;
	}

	public set benchmarkLastQuarter(value: number) {
		this._benchmarkLastQuarter = value;
	}

	public get benchmarkYearToDate(): number {
		return this._benchmarkYearToDate;
	}

	public set benchmarkYearToDate(value: number) {
		this._benchmarkYearToDate = value;
	}

	public get benchmarkOneYear(): number {
		return this._benchmarkOneYear;
	}

	public set benchmarkOneYear(value: number) {
		this._benchmarkOneYear = value;
	}

	public get benchmarkThreeYear(): number {
		return this._benchmarkThreeYear;
	}

	public set benchmarkThreeYear(value: number) {
		this._benchmarkThreeYear = value;
	}

	public get benchmarkFiveYear(): number {
		return this._benchmarkFiveYear;
	}

	public set benchmarkFiveYear(value: number) {
		this._benchmarkFiveYear = value;
	}

	public get benchmarkSinceInception(): number {
		return this._benchmarkSinceInception;
	}

	public set benchmarkSinceInception(value: number) {
		this._benchmarkSinceInception = value;
	}

	public toString(): any {
		const returnsObj = {};
		Object.keys(this).forEach(property => {
			if (this[property] instanceof Date) {
				returnsObj[property] = this[property].getMonth() + 1 + '/' + this[property].getDate() + '/' + this[property].getFullYear();
			} else {
				returnsObj[property] = this[property];
			}
		});
		return returnsObj;
	}
}
